<template>
  <v-card>
    <v-card-title><span class="headline"> {{ tituloCadastro }}</span></v-card-title>
      <v-spacer />
      <v-card-text>
      
        <v-sheet
          class="overflow-hidden"
          style="position: relative;"
        >

          <time-line-status ref="timeLineStatus" :processo_id="processoId" :mostrar="mostrarTimeLine" @fechar="mostrarTimeLine = false"></time-line-status>

          <v-card :loading="loading">

            <v-alert v-if="erros" type="error">
              {{ erros }}
            </v-alert>

            <v-overlay
              :absolute="true"
              :value="loading"
            >
                <v-progress-circular
                :size="50"
                color="success"
                indeterminate
              >
              </v-progress-circular>
            </v-overlay>

            <v-tabs
              v-model="tabPrincipal"
              background-color="success"
              dark
            >
              <v-tab id="tab1" key="1" @click="setStateButton(true)">Processo</v-tab>
              <v-tab id="tab2" key="2" v-if="formProcesso.id" @click="setStateButton(true)">Arquivos</v-tab>
              <v-tab id="tab3" key="3" v-if="formProcesso.id" @click="setStateButton(false)" v-show="privilegioNotificaoProcesso">Notificações</v-tab>
              <v-tab id="tab4" key="4" v-if="formProcesso.id" @click="setStateButton(false)">Observações</v-tab>
              <v-tab id="tab5" key="5" v-if="formProcesso.id" @click="setStateButton(true)">Pagamento</v-tab>
            </v-tabs>

            <v-tabs-items v-model="tabPrincipal">  

              <!-- INI - TAB CADASTRO DO CLIENTE -->         
              <v-tab-item>
                <v-container>
                  <v-form
                    ref="formProcesso"
                  >
                  <v-row v-if="mostrarAlerta">
                      <v-col
                        cols="12"
                      >
                        <v-alert type="error">
                          ATENÇÃO: Processo Negado.
                        </v-alert>
                        <v-textarea
                          outlined
                          v-model="$v.formProcesso.ds_motnegado.$model"
                          :error-messages="validacaoForm($v.formProcesso.ds_motnegado, 'Motivo negado')"
                          label="Motivo negado"
                          autocomplete="nope"
                        ></v-textarea>
                      </v-col>
                  </v-row>
                  <!-- <pagamento-honorarios 
                    ref="formPgtoHonorario" 
                    v-if="mostrarPagoHonorario" 
                    :processo_id="formProcesso.id"
                    :status="formProcesso.statusprocesso_id"
                  ></pagamento-honorarios> -->
                    <v-row>
                      <v-col
                        cols="12"
                        md="6"
                      >
                      <!-- <v-menu offset-y top max-width="300">
                          <template v-slot:activator="{ on }">
                            <v-autocomplete
                              v-model="$v.formProcesso.cliente_id.$model"
                              :items="clientes"
                              :loading="isLoadingSearchClient"
                              v-on:keyup.prevent="buscarCliente($event)"
                              :error-messages="validacaoForm($v.formProcesso.cliente_id, 'Cliente')"
                              @contextmenu.prevent="on.click"
                              ref="searchCliente"
                              label="Cliente"
                              hide-no-data
                              placeholder="Insira um Nome ou Cpf para pesquisar"
                              v-remove-acentos="'uppercase'"
                              autocomplete="nope"
                            ></v-autocomplete>
                          </template>
                          <v-list color="blue-grey lighten-1">
                            <v-list-item
                              @click="inserirCliente()"
                            >
                              <v-list-item-title><h4>Inserir Cliente</h4></v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                          v-model="$v.formProcesso.cliente_id.$model"
                        -->

                        <v-autocomplete
                          v-model="$v.formProcesso.cliente_id.$model"
                          :items="clientes"
                          :loading="isLoadingSearchClient"
                          v-on:keyup.prevent="buscarCliente($event)"
                          :error-messages="validacaoForm($v.formProcesso.cliente_id, 'Cliente')"
                          ref="searchCliente"
                          label="Cliente"
                          hide-no-data
                          item-value="value"
                          item-text="text"
                          placeholder="Insira um Nome ou Cpf para pesquisar"
                          v-remove-acentos="'uppercase'"
                          autocomplete="disabled"
                        >
                          <template v-slot:append-outer>
                            <v-tooltip top dark color="grey darken-3">
                              <template v-slot:activator="{ on }">
                                <!--<v-icon
                                  :key="`icon-${isEditing}`"
                                  :color="isEditing ? 'success' : 'info'"
                                  @click="isEditing = !isEditing"
                                  v-text="isEditing ? 'mdi-check-outline' : 'mdi-circle-edit-outline'"
                                ></v-icon>  mdi-account-plus-->
                                <v-hover
                                  v-slot:default="{ hover }"
                                  open-delay="200"
                                >
                                  <v-slide-x-reverse-transition
                                    mode="out-in"
                                  >
                                    <v-icon
                                      :size="hover ? 'x-large' : 'large'"
                                      v-on="on"
                                      color="success"
                                      @click="inserirCliente()"
                                      v-text="hover ? 'mdi-account-plus' : 'mdi-account-circle'"
                                    />                          
                                  </v-slide-x-reverse-transition>
                                </v-hover>
                              </template>
                              <span class="white--text text--darken-4 subtitle-2">Inserir Novo Cliente</span>
                            </v-tooltip>
                          </template>
                        </v-autocomplete>
                      </v-col>              
                      
                      <v-col
                        cols="12"
                        md="3"
                      >
                        <v-menu
                          v-model="menuDataInclusao"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          offset-y
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              v-model="dataInclusaoFormatada"
                              label="Data Inclusão"
                              prepend-icon="mdi-calendar"
                              readonly
                              :error-messages="validacaoForm($v.formProcesso.dt_inclusao, 'Data Inclusão')"
                              v-on="on"
                              autocomplete="nope"
                            ></v-text-field>
                          </template>
                          <v-date-picker 
                            no-title
                            disabled
                            v-model="$v.formProcesso.dt_inclusao.$model" 
                            @input="menuDataInclusao = false"
                            ></v-date-picker>
                        </v-menu>
                      </v-col>

                      <v-col
                        cols="12"
                        md="3"
                      > 
                        <v-select
                          v-model="$v.formProcesso.statusprocesso_id.$model"
                          :items="statusProcessoFilter"
                          :error-messages="validacaoForm($v.formProcesso.statusprocesso_id, 'Status')"
                          @change="tratarStatusProcesso"
                          label="Status"
                          ref="statusSelecionado"
                          autocomplete="nope"
                          item-text="text"
                          item-value="value"
                        >
                          <template v-slot:append-outer>
                            <v-tooltip top dark color="grey darken-3">
                              <template v-slot:activator="{ on }">
                                <v-hover v-slot:default="{ hover }" open-delay="200" >
                                  <v-icon
                                    v-show="formProcesso.id"
                                    v-on="on"
                                    :size="hover ? 'x-large' : 'large'"
                                    color="success"
                                    v-text="'mdi-timeline-clock-outline'"
                                    @click.stop="mostrarTimeLine = !mostrarTimeLine"
                                  />
                                </v-hover>
                              </template>
                              <span class="white--text text--darken-4 subtitle-2">Timeline Status</span>
                            </v-tooltip>
                          </template>
                        </v-select>
                        
                      </v-col>




                      <v-col
                        cols="12"
                        md="4"
                        v-show="mostrarDataPericia"
                      >
                        <v-text-field
                          v-mask="'##/##/####'"
                          v-model="$v.formProcesso.dt_pericia.$model"
                          :error-messages="validacaoForm($v.formProcesso.dt_pericia, 'Data Perícia')"
                          label="Data Perícia"
                        ></v-text-field>
                        <!--<v-menu
                          v-model="menuDataPericia"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          offset-y
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              v-show="mostrarDataPericia"
                              v-model="dataPericiaFormatada"
                              label="Data Perícia"
                              prepend-icon="mdi-calendar"
                              readonly
                              clearable
                              :error-messages="validacaoForm($v.formProcesso.dt_pericia, 'Data Perícia')"
                              v-on="on"
                              autocomplete="nope"
                            ></v-text-field>
                          </template>
                          <v-date-picker 
                            no-title
                            v-model="$v.formProcesso.dt_pericia.$model" 
                            @input="menuDataPericia = false"
                            :min="formProcesso.dt_inclusao"
                            ></v-date-picker>
                        </v-menu> -->
                      </v-col>
                      <v-col
                        cols="12"
                        :md="mostrarDataPericia ? 4 : 6"
                      >
                        <v-select
                          v-model="$v.formProcesso.tipoprocesso_id.$model"
                          :items="tipoProcessos || []"
                          :error-messages="validacaoForm($v.formProcesso.tipoprocesso_id, 'Tipo Processo')"
                          label="Tipo Processo"
                          @change="buscarDropDownCategoria($v.formProcesso.tipoprocesso_id.$model)"
                          item-disabled=""
                          autocomplete="nope"
                          item-text="text"
                          item-value="value"
                          :value="$v.formProcesso.tipoprocesso_id.$model"
                        >
                        </v-select>
                      </v-col>

                      <v-col
                        cols="12"
                        :md="mostrarDataPericia ? 4 : 6"
                      >
                        <v-select
                          v-model.lazy="$v.formProcesso.categoriaprocesso_id.$model"
                          :items="categoriasFilter || []"
                          :error-messages="validacaoForm($v.formProcesso.categoriaprocesso_id, 'Categoria Processo')"
                          label="Categoria Processo"
                          :loading="loadingCategorias"
                          @change="buscarPendencias"
                          autocomplete="nope"
                          item-text="text"
                          item-value="value"
                        ></v-select> <!-- :value-comparator="valueCompare" -->
                      </v-col>





                    <v-col
                        cols="12"
                        lg="6"
                      >
                        <v-select
                          v-model="$v.formProcesso.captador_id.$model"
                          :items="getDropDownColaborador()"
                          :error-messages="validacaoForm($v.formProcesso.captador_id, 'Captador')"
                          label="Captador"
                          item-text="text"
                          item-value="value"
                        ></v-select>

                      </v-col>

                      <v-col
                        cols="12"
                        lg="3"
                      >
                        <v-text-field
                          v-mask="'##/##/####'"
                          v-model="$v.formProcesso.dt_sinistro.$model"
                          :error-messages="validacaoForm($v.formProcesso.dt_sinistro, 'Data Sinistro')"
                          label="Data Sinistro"
                        ></v-text-field>
                        <!--<v-menu
                          v-model="menuDataSinistro"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          offset-y
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              v-model="dataSinistroFormatada"
                              label="Data Sinistro"
                              prepend-icon="mdi-calendar"
                              readonly
                              clearable
                              :error-messages="validacaoForm($v.formProcesso.dt_sinistro, 'Dt. Sinistro')"
                              v-on="on"
                              autocomplete="nope"
                            ></v-text-field>
                          </template>
                          <v-date-picker 
                            no-title 
                            v-model="$v.formProcesso.dt_sinistro.$model" 
                            @input="menuDataSinistro = false"
                            ></v-date-picker>
                        </v-menu> -->
                      </v-col>

                      <v-col
                        cols="12"
                        lg="3"
                      >
                        <v-text-field
                          v-model="$v.formProcesso.nr_documento.$model"
                          :error-messages="validacaoForm($v.formProcesso.nr_documento, 'Nro Documento')"
                          label="Nro Documento"
                          autocomplete="disabled"
                        ></v-text-field>
                      </v-col>

                      



                      
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-autocomplete
                          v-model="$v.formProcesso.acionado_id.$model"
                          :items="acionados"
                          :loading="isLoadingSearchAcionado"
                          v-on:keyup.prevent="buscarAcionado($event)"
                          :error-messages="validacaoForm($v.formProcesso.acionado_id, 'Acionado')"
                          ref="searchAcionado"
                          label="Acionado"
                          hide-no-data
                          placeholder="Insira um Nome ou Cpf para pesquisar"
                          v-remove-acentos="'uppercase'"
                          autocomplete="nope"
                        >
                          <template v-slot:append-outer>
                            <v-tooltip top dark color="grey darken-3">
                              <template v-slot:activator="{ on }">
                                <v-hover
                                  v-slot:default="{ hover }"
                                  open-delay="300"
                                >
                                  <v-icon
                                    :size="hover ? 'x-large' : 'large'"
                                    v-on="on"
                                    color="success"
                                    @click="inserirGenerico('Acionado')"
                                    v-text="hover ? 'mdi-account-plus' : 'mdi-briefcase-account'"
                                  />
                                </v-hover>
                              </template>
                              <span class="white--text text--darken-4 subtitle-2">Inserir Novo Acionado</span>
                            </v-tooltip>
                          </template>
                        </v-autocomplete>
                      </v-col>

                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-autocomplete
                          v-model="$v.formProcesso.responsavel_id.$model"
                          :items="terceiros"
                          :loading="isLoadingSearchTerceiro"
                          v-on:keyup.prevent="buscarTerceiro($event)"
                          ref="searchTerceiro"
                          label="Terceiro"
                          hide-no-data
                          placeholder="Insira um Nome ou Cpf para pesquisar"
                          autocomplete="disabled"
                          v-remove-acentos="'uppercase'"
                        >
                          <template v-slot:append-outer>
                            <v-tooltip top dark color="grey darken-3">
                              <template v-slot:activator="{ on }">
                                <v-hover
                                  v-slot:default="{ hover }"
                                  open-delay="300"
                                >
                                  <v-icon
                                    :size="hover ? 'x-large' : 'large'"
                                    v-on="on"
                                    color="success"
                                    @click="inserirGenerico('Terceiro')"
                                    v-text="hover ? 'mdi-account-plus' : 'mdi-briefcase-account'"
                                  />
                                </v-hover>
                              </template>
                              <span class="white--text text--darken-4 subtitle-2">Inserir Novo Terceiro</span>
                            </v-tooltip>
                          </template>
                        </v-autocomplete>
                      </v-col>







                      <v-col
                        cols="12"
                        md="6"
                        class="my-0 py-0"
                      >
                        <div>Tipo de Cobertura</div>
                        <v-radio-group 
                          class="my-0 py-0"
                          v-model="$v.formProcesso.tp_cobertura.$model"
                          :error-messages="validacaoForm($v.formProcesso.tp_cobertura, 'Tipo Cobertura')"
                          style="display: inline !important;"
                          row
                        >
                          <!--<template v-slot:label>
                            <div>Tipo de Cobertura</div>
                          </template> -->
                          <v-radio value="Invalidez" class="col-md-3 col-sm-12">
                            <template v-slot:label>
                              <div>Invalidez</div>
                            </template>
                          </v-radio>
                          <v-radio value="Morte" class="col-md-3 col-sm-12">
                            <template v-slot:label>
                              <div>Morte</div>
                            </template>
                          </v-radio>
                          <v-radio value="DMH" class="col-md-3 col-sm-12">
                            <template v-slot:label>
                              <div>DMH</div>
                            </template>
                          </v-radio>
                        </v-radio-group>
                      </v-col>

                      <v-col
                        cols="12"
                        md="6"
                        class="my-0 py-0"
                      >
                        <div>Tipo de Gravidade</div>
                        <v-radio-group 
                          class="my-0 py-0"
                          v-model="$v.formProcesso.tp_gravidade.$model"
                          :error-messages="validacaoForm($v.formProcesso.tp_gravidade, 'Tipo Gravidade')"
                          style="display: inline !important;"
                          row
                        >
                          <!--<template v-slot:label>
                            <div>Tipo Gravidade</div>
                          </template> -->
                          <v-radio value="Cirurgia" class="col-md-3 col-sm-12">
                            <template v-slot:label>
                              <div>Cirurgia</div>
                            </template>
                          </v-radio>
                          <v-radio value="Fratura" class="col-md-3 col-sm-12">
                            <template v-slot:label>
                              <div>Fratura</div>
                            </template>
                          </v-radio>
                          <v-radio value="Tentativa" class="col-md-3 col-sm-12">
                            <template v-slot:label>
                              <div>Tentativa</div>
                            </template>
                          </v-radio>
                        </v-radio-group>
                      </v-col>


                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-textarea
                          outlined
                          v-model="$v.formProcesso.ds_sinistro.$model"
                          label="Descrição do Sinistro"
                          autocomplete="nope"
                          v-show="mostrarBox"
                          :readonly="true"
                        ></v-textarea>
                      </v-col>

                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-textarea
                          outlined
                          v-model="$v.formProcesso.ds_danosinistro.$model"
                          label="Descrição do Dano"
                          autocomplete="nope"
                          v-show="mostrarBox"
                          :readonly="true"
                        ></v-textarea>
                      </v-col>
                      
                    </v-row>


                    <v-row class="mx0 my0 px0 py0">
                      <pendencia-processo ref="formPendenciaProcesso"></pendencia-processo>
                    </v-row>



                  </v-form>

                </v-container>
              </v-tab-item>
              <!-- FIM - TAB CADASTRO DO CLIENTE -->

              <!-- INI - TAB ARQUIVOS DO CLIENTE -->
              <v-tab-item>
                <v-container>
                  <arquivos-processo ref="arquivoProcesso" :processo_id="formProcesso.id" :cliente_id="formProcesso.cliente_id"></arquivos-processo>
                </v-container>
              </v-tab-item>
              <!-- FIM - TAB ARQUIVOS DO CLIENTE -->

              <!-- Roma em 26/01/2021 -->
              <v-tab-item>
                <v-container>
                  <notificacoes :processo_id="formProcesso.id" :cliente_id="formProcesso.cliente_id"></notificacoes>
                </v-container>
              </v-tab-item>

              <v-tab-item>
                <v-container>
                 <observacao :processo_id="formProcesso.id"></observacao>
                </v-container>
              </v-tab-item>

              <v-tab-item :eager="true"> 
                <v-container>
                 <!-- <observacao :processo_id="formProcesso.id"></observacao> -->
                  <pagamentos-processo ref="formPagamentos" v-if="formProcesso.id" :status="formProcesso.statusprocesso_id" :processo_id="formProcesso.id" :data_processo="formProcesso.dt_inclusao"> </pagamentos-processo>
                </v-container>
              </v-tab-item>

            </v-tabs-items>

            <v-row justify="center">
              <v-dialog v-model="dialog" scrollable persistent width="998px">        
                <v-card>
                  <v-toolbar>
                    <v-card-title><span class="headline">Cadastro de {{ title }}</span></v-card-title>
                    <v-spacer />
                  </v-toolbar>
                  <v-card-text>
                  <cadastro-cliente ref="formCadastroCliente" v-if="dialog" @close="dialog=false"></cadastro-cliente>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="success darken-1" text @click="dialog=false" :loading="isloadingCliente">Voltar</v-btn>
                    <v-btn color="success darken-1" text v-on:click.prevent="gravarCliente" :loading="isloadingCliente">Salvar</v-btn>
                    <v-btn color="success darken-1" text v-on:click.prevent="selecionarCliente" :loading="isloadingGenerico">Selecionar</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-row>

          </v-card>

        </v-sheet>  
      </v-card-text>
    <v-card-actions class="mx-5">
      <v-spacer></v-spacer>
      <!--
      <v-btn color="success darken-1" @click="gerarProcessoJuridico()" v-show="!loadingStore && analiseJuridica">Gerar Proc. Jurídico</v-btn>
      <v-btn color="success darken-1" text @click="fecharModal" v-show="!loadingStore">Voltar</v-btn>
      <v-btn color="success darken-1" text v-on:click.prevent="callGravar" :loading="loadingStore" :disabled="!stateButton || !privilegioSalvar" >Salvar</v-btn>
      -->
      <v-btn color="success darken-1" @click="gerarProcessoJuridico()" v-show="!loadingStore && analiseJuridica">Gerar Proc. Jurídico</v-btn>
      <v-btn color="success darken-1" text @click="fecharModal" v-show="!loadingStore">Voltar</v-btn>
      <v-btn color="success darken-1" text v-on:click.prevent="gravar" :loading="loadingStore" :disabled="!stateButton || !privilegioSalvar" >Salvar</v-btn>
    </v-card-actions>
  </v-card>

</template>

<script>

import Notificacoes from '@/views/Notificacoes/Notificacoes'
import cadastroCliente from "@/views/Cliente/CadastroCliente"
import CadastroAcionado from "@/views/Acionado/CadastroAcionado"
import PagamentoHonorarios from './PagamentoHonorarios'
import ArquivosProcesso from './ArquivosProcesso'
import PendenciaProcesso from './PendenciaProcesso'
import TimeLineStatus from "./TimeLineStatus"
import PagamentosProcesso from "../Pagamentos/PagamentosView.vue"
import {required, requiredIf} from 'vuelidate/lib/validators'
import validacaoForm from '@/mixins/validacaoForm'
import utils from '@/mixins/utils'
import validaProcesso from '@/utils/validaProcesso'
import { mapGetters, mapActions, mapState, mapMutations } from 'vuex'
import apiClient from '@/plugins/axios'
import _ from 'lodash'
import privilegiosUsuario from "@/utils/privilegiosUsuario"
import Observacao from './Observacao'


export default {
  name: 'CadastroProcesso',
  props: {
    isExibirNotif: {
      type: Boolean,
      required: false
    }
  },
  components: {
    PendenciaProcesso,
    ArquivosProcesso,
    cadastroCliente,
    CadastroAcionado,
    TimeLineStatus,
    PagamentoHonorarios,
    Notificacoes,
    Observacao,
    PagamentosProcesso
  },

  mixins:[validacaoForm, utils],
  data () {
    return {
      tituloCadastro: 'Cadastro de Processo de Sinistro',
      teste: 12,
      mostrarTimeLine: false,
      isEditing: false,
      dialog: false,
      dialogGenerico: false,
      title: '',
      minHeightTab: 250,
      loadingBuscarCpfCnpj: false,
      tab: null,
      tabPrincipal: null,
      loading: false,
      formProcesso: {},
      clientes: [],
      acionados: [],
      terceiros: [],
      tipoProcessos: [],
      categoriasFilter: [],
      isLoadingSearchClient: false,
      isLoadingSearchAcionado: false,
      isLoadingSearchTerceiro: false,
      isloadingCliente: false,
      isloadingGenerico: false,
      loadingCategorias: false,
      menuDataInclusao: false,
      menuDataSinistro: false,
      menuDataPericia: false,
      categoria_id_old: null,
      tipoacionado_contexto: null,
      processoId: null,
      pgtoHonorario: false,
      statusProcessoGravado: '',
      formProcessoCompare: {},
      desabilita: false,
      analiseJuridica: false,
    }
  },
  validations: {
    formProcesso: {
      cliente_id: { required, errors: [] },
      dt_inclusao: { required, errors: [] },
      statusprocesso_id: { required, errors: [] },
      tipoprocesso_id: { required, errors: [] },
      categoriaprocesso_id: { required, errors: [] },
      tp_cobertura: { required, errors: [] },
      tp_gravidade: { required, errors: [] },
      dt_sinistro: { errors: [] },
      nr_documento: { errors: [] }, 
      acionado_id: { required, errors: [] },
      responsavel_id: { errors: [] },
      ds_sinistro: { errors: [] },
      ds_danosinistro: { errors: [] },
      captador_id: { errors: [] },
      dt_pericia: { 
        required: requiredIf((item) => {
          return validaProcesso.exigirDataPericia(item) 
          //if (item.statusprocesso_id == validaProcesso.status.CADASTRO) return false
          //return item.pericia_dispensada == false && item.statusprocesso_id >= validaProcesso.status.PERICIA_RECEBIDA ? true : false 
        }), 
        errors: [] 
      },
      ds_motnegado: { 
        required: requiredIf((item) => validaProcesso.status.NEGADO == item.statusprocesso_id), 
        errors: [] 
      },
    },
  },
  beforeDestroy: function () {
    this.destroy()
  },
  async created() {
    this.resetErros()
    this.categoria_id_old = null
    this.setStateButton(true)
    
  },  
  async mounted() {
    this.loading = true
    this.tabPrincipal = 0
    await this.sincronizarProcesso(this.processoSelecionado)
    await this.actLoadCropDownCategoria()
    await this.actDropDownStatusProcesso()
    this.tipoProcessos = await this.getDropDownTipoProcessos()
    this.loading = false
    if (this.isExibirNotif) { 
      this.tabPrincipal = 2
      this.setStateButton(false)
    }
    
  },

  methods: {
    ...mapActions({
      storeProcesso: 'processo/STORE_PROCESSO',
      actDropDownStatusProcesso: 'statusprocesso/LOAD_DROPDOWN',
      actLoadCropDownCategoria: 'categoria/LOAD_DROPDOWN',
      actGetPendenciaProcesso: 'processo/GET_PENDENCIAPROCESSO',
      clienteSelecionado: 'cliente/CLIENTE_SELECTED',
      resetClienteSelecionado: 'cliente/RESET_SELECTED',
      acionadoSelecionado: 'acionado/ACIONADO_SELECTED',
      resetAcionadoSelecionado: 'acionado/RESET_SELECTED',
    }),
    ...mapGetters({
      getErros: 'processo/GET_ERROS',
      getDropDownTipoProcessos: 'tipoprocesso/GET_DROPDOWN',
      getDropDownColaborador: 'colaborador/GET_DROPDOWN',
      getDropDownCategorias: 'categoria/GET_DROPDOWN',
      getProcessoSelecionado: 'processo/PROCESSO_SELECIONADO',
    }),
    ...mapMutations({
      commitErro: 'processo/SET_ERROS',
      resetErros: 'processo/ERASE_ERROS',
      setStateButton: 'processo/SET_STATE_BUTTON'
    }),
    async fecharModal() {
      /*
        se o 'stateButton' for false é porque o usuário não tem permissão
        para alterar os dados, então já aborta a tentativa de gravação
      */
      if (!this.privilegioSalvar) {
        this.$emit('close')
        return
      } 

      if (await this.formFoiAlterado()) {
        this.$dialog.confirm("Dados foram alterados. Deseja fechar e perder alterações?", {loader: true, okText: 'Sim', cancelText: 'Não',})
        .then(async (dialog) => {
            this.$emit('close')
            dialog.close() 
        })
      } else {
        this.$emit('close')
      } 

    },
    async inserirCliente() {
      this.title = 'Cliente'
      await this.resetClienteSelecionado()
      await this.clienteSelecionado()
      this.dialog = true
    },
    async gravarCliente () {
      this.isloadingCliente = true
      try {
        await this.$refs.formCadastroCliente.gravarComRetorno()
      } catch (error) {
        console.log(error)
      } finally {
        this.isloadingCliente = false
      }
    },
    async selecionarCliente() {
      try {
        let retorno = await this.$refs.formCadastroCliente.selecionar()
        if (!retorno.status) {
          this.$toaster.error('Você deve gravar antes de Selecionar.')
          return
        }
        this.clientes = []
        this.clientes.push(retorno)
        this.formProcesso.cliente_id = retorno.value
        this.dialog = false
      } catch(error) {

      }
    },
    async inserirGenerico(tipo) {
      this.title = tipo
      this.tipoacionado_contexto = null
      if (tipo === 'Terceiro') this.tipoacionado_contexto = 2
      await this.resetAcionadoSelecionado()
      await this.acionadoSelecionado()
      this.dialogGenerico = true
    },
    async gravarGenerico () {
      this.isloadingGenerico = true
      try {
        await this.$refs.formCadastroGenerico.gravarComRetorno()
      } catch (error) {
        console.log(error)
      } finally {
        this.isloadingGenerico = false
      }
    },
    async selecionarGenerico() {
      try {
        let retorno = await this.$refs.formCadastroGenerico.selecionar()
        if (!retorno.status) {
          this.$toaster.error('Você deve gravar antes de Selecionar.')
          return
        }
        if (this.tipoacionado_contexto === 2 ) {
          this.terceiros = []
          this.terceiros.push(retorno)
          this.formProcesso.responsavel_id = retorno.value
        } else {
          this.acionados = []
          this.acionados.push(retorno)
          this.formProcesso.acionado_id = retorno.value
        }
        this.dialogGenerico = false
      } catch(error) {

      }
    },
    buscarCliente(event) {
      if (!this.digitoTecladoValido(event.keyCode)) return
      if (!event.target.value) return
      this.debounceCliente(event)
    },
    debounceCliente: _.debounce(async function (event) {
      this.isLoadingSearchClient = true      
      let _value = event.target.value
      this.clientes = []
      this.resetErros()

      try {      
        let ret = await this.axiosGetCliente(_value)
        if (ret) {
          this.clientes = ret
          this.clientes.unshift({ text: '', value: '' })
          var reg = new RegExp('^[0-9]*$');
          if (reg.test(_value)) this.$refs.searchCliente.lazySearch = this.clientes.length ? null : _value
        }
      } catch (error) {
        this.erros = 'Erro ao buscar cliente'
      } finally {
        this.isLoadingSearchClient = false
      }
    }, 500),
    async axiosGetCliente(_value) {
      let ret = []
      await apiClient.post(`cliente/getwithparams`, {
        filter: _value
      })
      .then(response => {
        let dados = response.data.clientes
        if (dados) {
           ret = dados.map( (item) => {
            return Object.assign({}, { text: item.nm_pessoa, value: item.id })
          })          
        }
      })
      .catch(err => {
        console.log(err)
      })
      return ret      
    },
    buscarAcionado(event) {
      if (!this.digitoTecladoValido(event.keyCode)) return
      if (!event.target.value) return
      this.debounceAcionado(event)
    },
    debounceAcionado: _.debounce(async function (event) {
      this.isLoadingSearchAcionado = true      
      let _value = event.target.value
      this.acionados = []
      this.resetErros()

      try {      
        let ret = await this.axiosGetAcionado({ pessoa: _value })
        if (ret) {
          this.acionados = ret
          this.acionados.unshift({ text: '', value: '' })
          var reg = new RegExp('^[0-9]*$');
          if (reg.test(_value)) this.$refs.searchAcionado.lazySearch = this.acionados.length ? null : _value
        }
      } catch (error) {
        this.erros = 'Erro ao buscar acionado'
      } finally {
        this.isLoadingSearchAcionado = false
      }
    }, 500),
    async axiosGetAcionado(filter) {
      let ret = []
      await apiClient.post(`acionadosProcesso/getwithparams`, {
        filter: filter
      })
      .then(response => {
        let dados = response.data.acionados
        if (dados) {
           ret = dados.map( (item) => {
            return Object.assign({}, { text: item.nm_pessoa, value: item.id })
          })          
        }
      })
      .catch(err => {
        console.log(err)
      })
      return ret      
    },
    buscarTerceiro(event) {
      if (!this.digitoTecladoValido(event.keyCode)) return 
      if (!event.target.value) return
      this.debounceTerceiro(event)
    },
    debounceTerceiro: _.debounce(async function (event) {
      this.isLoadingSearchTerceiro = true      
      let _value = event.target.value
      this.terceiros = []
      this.resetErros()

      try {
        let ret = await this.axiosGetAcionado({ pessoa: _value, tipoacionado_id: 2 })
        if (ret) {
          this.terceiros = ret
          this.terceiros.unshift({ text: '', value: '' })
          var reg = new RegExp('^[0-9]*$');
          if (reg.test(_value)) this.$refs.searchTerceiro.lazySearch = this.terceiros.length ? null : _value
        }
      } catch (error) {
        this.erros = 'Erro ao buscar acionado'
      } finally {
        this.isLoadingSearchTerceiro = false
      }
    }, 500),
    async buscarPendencias(item) {
      if (this.categoria_id_old !== item && this.categoria_id_old && item > 0) {
        this.$dialog.confirm("Ao alterar Categoria do Processo, Documentos Pendentes serão alterados e suas seleções serão perdidas. Deseja continuar?", {loader: true, okText: 'Sim', cancelText: 'Não',})
        .then(async (dialog) => {
          try {
            await this.actGetPendenciaProcesso({idProcesso: this.formProcesso.id, idCategoria: item})
            this.categoria_id_old = item
          } catch (e) {
            this.commitErro({ erros: "Erro ao enviar dados para Api 'buscarDocumentosRequisitados'" })
            this.formProcesso.categoriaprocesso_id = this.categoria_id_old
          } finally {
            dialog.close();
          }
        })
        .catch((e) => {
          this.formProcesso.categoriaprocesso_id = this.categoria_id_old
        })
      } else {
        await this.actGetPendenciaProcesso({idProcesso: this.formProcesso.id, idCategoria: item})
        this.categoria_id_old = item  
      }
    },
    sincronizarProcesso (processo) {
      this.processoId = null
      this.formProcesso = Object.assign(
        {},
        processo
      )
      this.inicializacao()
   },
   habilitaBotaoGerarJuridico() {
     this.mostrarBotaoGerarJuridico(false)
     if (this.formProcesso.tipoprocesso_id == 2) return
     if (this.statusProcessoGravado == validaProcesso.status.ANALISE_JURIDICA && !this.formProcesso.gerprocjur) this.mostrarBotaoGerarJuridico(true)
     if (this.statusProcessoGravado == validaProcesso.status.NEGADO && !this.formProcesso.gerprocjur) this.mostrarBotaoGerarJuridico(true)
   },
    async gravar() {
      this.resetErros()
      this.loading = true
      this.commitErro({erros: ''})
      if (!(await this.validaForm())) {
        this.tabPrincipal = 0
        this.commitErro({erros: 'Verifique campos obrigatórios'})
        this.loading = false
        return
      }
      if (this.$refs.formPendenciaProcesso) {
        let objPendencias = await this.$refs.formPendenciaProcesso.gravar()
        this.formProcesso.pendencia_processo = objPendencias
      }
      /*if (this.$refs.formPgtoHonorario) {
        if (!await this.$refs.formPgtoHonorario.validaForm()) {
          this.tabPrincipal = 0
          this.commitErro({erros: 'Verifique campos obrigatórios em Pagamento'})
          this.loading = false
          return false
        }      
        let objPgto = await this.$refs.formPgtoHonorario.gravar()
        this.formProcesso.pagamento_honorario = Object.assign({}, objPgto)
      }*/
      if (this.formProcesso.id && this.$refs.arquivoProcesso) {
        if (!this.$refs.arquivoProcesso.gravarDescricao()) {
          this.tabPrincipal = 0
          this.commitErro({erros: 'Verifique campos obrigatórios em Arquivos)'})
          this.loading = false
          return false
        }
      }
      if (this.$refs.formPagamentos ) {
        if (!(await this.$refs.formPagamentos.validaForm())) {
          this.tabPrincipal = 4
          this.loading = false
          return false
        }
        if (!(await this.$refs.formPagamentos.gravar())) {
          this.$toaster.error('Erro ao gravar!');
          this.tabPrincipal = 4
          this.loading = false
          return false
        }
      }
      if (!(await this.store())) {
        this.$toaster.error('Erro ao gravar!');
        return
      }
      this.$toaster.success('Gravação efetuada com sucesso!');
      this.loading = false
    },
    async validaForm () {
      this.$v.formProcesso.$touch();
      if (!this.$v.formProcesso.$invalid) {
        return true
      } else if (this.$v.formProcesso.$anyError) {
        return false
      }
    },
    async store () {
      var processo = JSON.parse(JSON.stringify(this.formProcesso))
      processo.dt_pericia = this.converteDataParaApi(processo.dt_pericia)
      processo.dt_sinistro = this.converteDataParaApi(processo.dt_sinistro)
      if (!this.dataValida(processo.dt_sinistro)) {
        this.commitErro({erros: "Data Sinistro Inválida" })
        this.loading = false
        return false
      }
      if (!this.dataValida(processo.dt_pericia)) {
        this.commitErro({erros: "Data Sinistro Inválida" })
        this.loading = false
        return false
      }
      try {
        await this.storeProcesso(processo)
        if (this.erros) return false
        return true        
      } catch(e) {
        this.commitErro({erros: "Erro não tratado em 'store'" })
        console.log(e)
        return false

      } finally {
        this.loading = false
      }
    },
    async buscarDropDownCategoria(value) {
      if (value) { 
        this.categoriasFilter = this.getDropDownCategorias().filter(item => item.tipoprocesso_id == value)
      } else {
        this.categoriasFilter = this.getDropDownCategorias()
      }
    },
    tratarStatusProcesso(status) {
      if (!status) this.formProcesso.pericia_dispensada = false
      if (validaProcesso.status.CADASTRO == status) this.formProcesso.pericia_dispensada = false
      if (validaProcesso.status.PENDENCIA_ADM == status) this.formProcesso.pericia_dispensada = false
      if (validaProcesso.status.PENDENCIA_JURIDICO == status) this.formProcesso.pericia_dispensada = false
      if (validaProcesso.status.PERICIA_AGENDADA == status) this.formProcesso.pericia_dispensada = false
      if (validaProcesso.status.PERICIA_DISPENSADA == status) this.formProcesso.pericia_dispensada = true
      if (this.formProcesso.pericia_dispensada == true) this.formProcesso.dt_pericia = null
    },
    inicializacao() {
      if (!this.formProcesso.dt_inclusao) this.formProcesso.dt_inclusao = this.$moment().format('YYYY-MM-DD')
      this.categoria_id_old = this.formProcesso.categoriaprocesso_id
      if (this.formProcesso.categoriaprocesso_id > 0) this.actGetPendenciaProcesso({idProcesso: this.formProcesso.id, idCategoria: this.formProcesso.categoriaprocesso_id})

      //preencher itens da lista Categoria do Processo
      this.buscarDropDownCategoria(this.formProcesso.tipoprocesso_id)

      let tstCli = null
      this.clientes = []
      if (this.formProcesso && this.formProcesso.cliente) {
        tstCli = null
        tstCli = this.clientes.filter( item => { return item.value == this.formProcesso.cliente.id })
        if (tstCli) this.clientes.push({ "text": this.formProcesso.cliente.pessoa.nm_pessoa, "value": this.formProcesso.cliente.id })
      }
      if (this.formProcesso && this.formProcesso.acionado) {
        tstCli = null
        tstCli = this.acionados.filter( item => { return item.id === this.formProcesso.acionado.id })
        if (tstCli) this.acionados.push({ text: this.formProcesso.acionado.pessoa.nm_pessoa, value: this.formProcesso.acionado.id })
      }
      if (this.formProcesso && this.formProcesso.terceiro) {
        tstCli = null
        tstCli = this.terceiros.filter( item => { return item.id === this.formProcesso.terceiro.id })
        if (tstCli) this.terceiros.push({ text: this.formProcesso.terceiro.pessoa.nm_pessoa, value: this.formProcesso.terceiro.id })
      }
      this.processoId = this.formProcesso.id
      if (this.formProcesso.id > 0 && this.$refs.timeLineStatus) this.$refs.timeLineStatus.atualizarProcessoStatus(this.formProcesso.id)
   
      this.pgtoHonorario = this.formProcesso.pagamento_honorario && this.formProcesso.pagamento_honorario.id ? true : false

      this.formProcesso.dt_sinistro = this.converteDataParaView(this.formProcesso.dt_sinistro)
      this.formProcesso.dt_pericia = this.converteDataParaView(this.formProcesso.dt_pericia)
      this.statusProcessoGravado = this.formProcesso.statusprocesso_id
      this.habilitaBotaoGerarJuridico()
      this.formProcessoCompare = Object.assign({}, this.formProcesso)
      //if (this.$refs.formPgtoHonorario) this.$refs.formPgtoHonorario.buscarPagamento()
    },
    async formFoiAlterado() {
      let formAlterado = !(_.isEqual(this.formProcesso, this.formProcessoCompare))
      if (formAlterado) return true
      formAlterado = await this.$refs.formPendenciaProcesso.formFoiAlterado()
      if (formAlterado) return true
      if ( this.$refs.arquivoProcesso) {
        formAlterado = await this.$refs.arquivoProcesso.formFoiAlterado()
      }
      if (formAlterado) return true
      return false
    },
    mostrarBotaoGerarJuridico (event) {
      this.analiseJuridica = event
    },
    gerarProcessoJuridico() {
      let item = this.getProcessoSelecionado()
      this.$emit("gerarClone", item, true)
    },
  },
  watch: {
    async processoSelecionado(novo, antigo) {
      this.loading = true
      await this.sincronizarProcesso(novo)
      this.loading = false
    },
    erros(novo, antigo) {
      return novo
    },
    dropdownStatusProcesso (novo) {
      return novo
    }
  },
  computed: {
    ...mapState('processo', [
      'processoSelecionado',
      'loadingStore',
      'erros',
      'stateButton'
    ]),
    ...mapState('statusprocesso', [
      'dropdownStatusProcesso'
    ]),
    dataInclusaoFormatada: {
      get() {
        if (!this.formProcesso.dt_inclusao) return this.formProcesso.dt_inclusao
        return this.$moment(this.formProcesso.dt_inclusao, 'YYYY-MM-DD', true).format('DD/MM/YYYY')
      },
      set(newVal){
        this.formProcesso.dt_inclusao = newVal
      }
    },
    dataSinistroFormatada: {
      get: function() {
        if (!this.formProcesso.dt_sinistro) return this.formProcesso.dt_sinistro
        return this.$moment(this.formProcesso.dt_sinistro, 'YYYY-MM-DD', true).format('DD/MM/YYYY')
      },
      set(newVal) {
        return newVal
        this.formProcesso.dt_sinistro = newVal
      }
    },
    dataPericiaFormatada: {
      get: function() {
        if (!this.formProcesso.dt_pericia) return this.formProcesso.dt_pericia
        return this.$moment(this.formProcesso.dt_pericia, 'YYYY-MM-DD', true).format('DD/MM/YYYY')
      },
      set(newVal) {
        this.formProcesso.dt_pericia = newVal
      }
    },
    mostrarDataPericia() {
      return validaProcesso.exigirDataPericia(this.formProcesso)
    },
    statusProcessoFilter() {
      let contexto = validaProcesso.statusPorTipoCategoria(this.formProcesso.tipoprocesso_id, this.formProcesso.categoriaprocesso_id, this.statusProcessoGravado, this.dropdownStatusProcesso)       
      return contexto
    },
    mostrarAlerta() {
      if (!this.formProcesso.statusprocesso_id) return false
      return validaProcesso.status.NEGADO == this.formProcesso.statusprocesso_id ? true : false
    },
    mostrarPagoHonorario() {
      let mostrar = false
      if (validaProcesso.status.CLIENTE_INDENIZADO == this.formProcesso.statusprocesso_id) mostrar = true
      if (validaProcesso.status.HONORARIOS_PARCELADO == this.formProcesso.statusprocesso_id) mostrar = true
      if (validaProcesso.status.HONORARIOS_PAGO == this.formProcesso.statusprocesso_id) mostrar = true
      if (validaProcesso.status.ARQUIVO == this.formProcesso.statusprocesso_id && this.pgtoHonorario) mostrar = true
      if (validaProcesso.status.ANALISE_JURIDICA == this.formProcesso.statusprocesso_id && this.pgtoHonorario) mostrar = true
      return mostrar
    },
    privilegioNotificaoProcesso() {
      return privilegiosUsuario.permitirNotificacaoProcesso()
    },
    privilegioSalvar() {
      return privilegiosUsuario.permitirSalvarProcesso()
    },
    privilegioUsuarioNaoJuridico() {
      return privilegiosUsuario.permitirAcaoExcluirDocumento()
    },

    // //Romanhuk em 18/01/2022
    privilegioPagamentos() {
       return privilegiosUsuario.permitirAlterarPagamentoProcesso()
    },
      

    mostrarBox() {
      //return true
      let descBoxSinistro = this.formProcesso.ds_sinistro
      let descBoxDano = this.formProcesso.ds_danosinistro
      return descBoxDano || descBoxSinistro ? true : false
    }
    /*formProcesso.statusprocesso_id() {
      return this.formProcesso.formProcesso.statusprocesso_id_id
    }*/
  },
  beforeDestroy() {
    this.resetErros()
  }
}
</script>

<style scoped>
  .v-btn {
    padding: 0 !important;
  }
 
</style>



// WEBPACK FOOTER //
// src/views/Processo/CadastroProcesso.vue